import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Select from '../../../Part_Sample/Select';
import Editbox from '../../../Part_Sample/Editbox';
import { isEmpty } from '../../../Common/Common';
import Site_Selection_Cell from '../../../Part_Sample/Site_Selection_Cell';

export default class MSM_Add_Edit_Account extends Component {
	constructor(props) {
		super(props);

		let accounts = this.props.param.accounts;
		let username = '';
		let password = '';
		let user_class = 'Admin';

		let auth = {
			sites: {}
		};

		if (this.props.param.username != null) {
			let account = this.props.param.accounts[this.props.param.username];
			username = account.name;
			password = account.passwd;
			user_class = account['class'];
			if (!isEmpty(account.auth)) {
				if (account.auth.sites != null) {
					for (let site_id in account.auth.sites) {
						auth.sites[site_id] = account.auth.sites[site_id];
					}
				}
			}
		}

		/*
		 *  Password is hashed in server side. No way to retrieve the original password.
		 *  Check if the password is changed.
		 *  If password is changed, send new password. Else send password = null
		 */
		this.is_password_changed = false;

		this.state = {
			username: username,
			password: password,
			user_class: user_class,
			auth: auth,
		}
	}

	handlePrevious = () => {
		this.props.content_handler('User_Administration', { accounts: this.props.param.accounts });
	}

	handleChangeUsername = (val) => {
		this.setState({ username: val })
	}

	handleChangePassword = (val) => {
		this.is_password_changed = true;
		this.setState({ password: val })
	}

	handleChangeUserClass = (val) => {
		this.setState({ user_class: val })
	}

	handleSelectSite = (selected_site_id) => {
		let auth = this.state.auth;
		if (auth.sites[selected_site_id] != null) {
			// Existing already selected
			delete auth.sites[selected_site_id];
		} else {
			// haven add yet
			auth.sites[selected_site_id] = true;
		}

		this.setState({ auth: auth });
	}

	handleRegister = () => {
		if (this.state.username == '') {
			window.app.showToast(this.props.receiver.getString('no_username'), 3000);
			return;
		} else if (this.state.username == 'setup') {
			window.app.showToast(this.props.receiver.getString('cannot_use_setup'), 3000);
			return;
		} else if (this.state.password == '') {
			window.app.showToast(this.props.receiver.getString('no_password'), 3000);
			return;
		}

		let account_details = {};
		account_details.name = this.state.username;
		account_details.passwd = this.is_password_changed == true ? this.state.password : null;
		account_details['class'] = this.state.user_class;

		let auth = this.state.auth;
		account_details.auth = auth;

		if (this.props.param.username == null) {
			this.props.receiver.addAccount(account_details);
		} else {
			let account = this.props.param.accounts[this.props.param.username];
			account_details.id = account.id;
			this.props.receiver.modifyAccount(account_details);
		}
	}

	handleDelete = () => {
		this.props.receiver.deleteAccount({ name: this.props.param.username });
	}

	rcvAddAccount(response) {
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'User_Administration';
			this.props.receiver.getAccounts();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvModifyAccount(response) {
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'User_Administration';
			this.props.receiver.getAccounts();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvDeleteAccount(response) {
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'User_Administration';
			this.props.receiver.getAccounts();
		} else {
			window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let container_style = {
			width: this.props.width - 60,
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			padding: 10,
		}

		const class_range = [];
		if (this.state.user_class == 'Admin') {
			class_range.push(<option selected value={'Admin'}>{this.props.receiver.getString('admin')}</option>);
			class_range.push(<option value={'User'}>{this.props.receiver.getString('user')}</option>);
		} else if (this.state.user_class == 'User') {
			class_range.push(<option value={'Admin'}>{this.props.receiver.getString('admin')}</option>);
			class_range.push(<option selected value={'User'}>{this.props.receiver.getString('user')}</option>);
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.username == null ? this.props.receiver.getString('add_account') : this.props.receiver.getString('edit_account')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ marginTop: 20, height: this.props.height - 120, overflow: 'auto' }}>
						<div style={{ width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto' }}>
							<Editbox id='username' read_only={this.props.param.username != null ? true : false} placeholder={this.props.receiver.getString('usrname')} inputType='text' onChange={(event) => this.handleChangeUsername(event.target.value)} value={this.state.username} />
						</div>
						<div style={{ width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto' }}>
							<Editbox id='passwd' placeholder={this.props.receiver.getString('passwd')} inputType='password' onChange={(event) => this.handleChangePassword(event.target.value)} value={this.state.password} />
						</div>

						<div id='general' style={container_style}>
							<div style={{}}>
								<span className="header">{this.props.receiver.getString('general')}</span>
							</div>
							<div id='user_class' style={{ marginLeft: 10, textAlign: 'left' }}>
								<div style={{ display: 'inline-block', width: this.props.width - 220 }}>
									<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('user_class')}</span>
								</div>
								<div style={{ display: 'inline-block', width: 150 }}>
									<div style={{ display: this.props.param.username != null ? 'inline-block' : 'none', width: '100%', textAlign: 'right' }}>
										<span style={{ marginRight: 10, fontWeight: 500, fontSize: 20 }}>{this.state.user_class}</span>
									</div>
									<Select
										style={{ display: this.props.param.username == null ? 'inline-block' : 'none' }}
										select_style={{ fontSize: 20, height: 35 }}
										options={class_range}
										value={this.state.user_class}
										onSelect={this.handleChangeUserClass}
									/>
								</div>
							</div>
						</div>
						<div id='authority' style={{ ...container_style, marginBottom: 20, display: this.state.user_class == 'Admin' ? 'none' : 'block' }}>
							<div>
								<span className="header">{this.props.receiver.getString('authority')}</span>
							</div>
							<div id='target' style={{ display: this.state.user_class == 'Admin' ? 'none' : 'block', marginTop: 10, marginLeft: 10, maxHeight: this.props.height - 170, overflow: 'auto', textAlign: 'left' }}>
								<div style={{ textAlign: 'left' }}>
									<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('sites')}</span>
								</div>
								{Object.keys(window.app.state.site_list).map((site_id) => {
									let site_info = window.app.state.site_list[site_id];
									if (!isEmpty(site_info)) {
										return (
											<Site_Selection_Cell
												style={{ width: this.props.width - 80 }}
												id={site_id}
												height={this.props.height}
												width={this.props.width}
												key={site_id}
												handleSetToggle={this.handleSelectSite}
												site_info={site_info}
												is_selected={this.state.auth.sites[site_id]}
											/>
										)
									} else {
										return null;
									}
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}